import GlobalSearchState, { SearchBlockOpType } from "../typings";
import DropdownBase, { DropdownBaseProps } from "./common/DropdownBase";
import Utils from "./common/Utils";

export default class DropdownOperator extends DropdownBase<DropdownBaseProps> {
	
	public get opType(): SearchBlockOpType{
		return SearchBlockOpType[this.toggleButton?.text()];
	}

	constructor(type: string, action: (value: string) => void) {

		super({
			buttons: [
				GlobalSearchState.andOperatorText, 
				GlobalSearchState.orOperatorText, 
				GlobalSearchState.notOperatorText
			].map(t => { 
				return { 
					text: Utils.translatedOperators[t],
					selected: type === t, 
					action: () => this.hideOnClick(() => { 
						this.updateToggleText(Utils.translatedOperators[t]); 
						action(t); 
					})
				};
			}),
			id: "rfe-searchOperator"
		});
	}

	protected renderContainerInternal(): JQuery {
		return $("<div>")
			.addClass("rup-global-search__chip rup-global-search__chip--operator")
			.attr("data-test-id", "search-operator");
	}
}
